<app-payment-request-summary [expanded]="true" [hideTitle]="true" [entity]="paymentRequest">
    <app-button buttons
                iconName="trash"
                tooltip="Annuler l'encaissement"
                [loading]="service.loading$ | async"
                (clickEvent)="removeAllMovements()">
    </app-button>
</app-payment-request-summary>

